// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var $$String = require("rescript/lib/js/string.js");
var Cookie = require("cookie");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_null = require("rescript/lib/js/js_null.js");
var Faunadb = require("faunadb");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.bs.js");
var Query = require("faunadb/src/query");
var Apollo$SmartcutsMacros = require("../../packages/data/src/Apollo.bs.js");
var URLUtils$SmartcutsMacros = require("../../packages/bs-utils/src/URLUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../packages/bs-utils/src/OptionUtils.bs.js");

var IdentityResponse = {};

function make(cookie) {
  return $$String.split_on_char(/* ';' */59, cookie);
}

function getCookie(name, cookies) {
  return Belt_Option.flatMap(Belt_List.getBy(cookies, (function (c) {
                    return c.trim().startsWith(name);
                  })), (function (rawCookie) {
                var match = $$String.split_on_char(/* '=' */61, rawCookie);
                if (!match) {
                  return ;
                }
                var match$1 = match.tl;
                if (match$1 && !match$1.tl) {
                  return decodeURIComponent(match$1.hd);
                }
                
              }));
}

var CookieJar = {
  make: make,
  getCookie: getCookie
};

var $$global = {
  apolloClient: undefined
};

function setGlobalApolloClient(_client) {
  return (globalApolloClient = _client);
}

var OptionalPageProps = {};

function maybeDecodeUserFlags(maybeJsonString) {
  return Belt_Option.flatMap(maybeJsonString, (function (jsonString) {
                try {
                  return Json_decode.array(Json_decode.string, JSON.parse(jsonString));
                }
                catch (exn){
                  return ;
                }
              }));
}

function getServerSideProps(param) {
  var res = param.res;
  var req = param.req;
  return new Promise((function (resolve, param) {
                var cookie = Js_dict.get(req.headers, "cookie");
                if (cookie !== undefined) {
                  var jar = $$String.split_on_char(/* ';' */59, cookie);
                  var match = getCookie(process.env.NEXT_PUBLIC_FAUNA_SECRET_COOKIE_NAME, jar);
                  var match$1 = getCookie("userId", jar);
                  var match$2 = getCookie("email", jar);
                  var match$3 = getCookie("role", jar);
                  var match$4 = getCookie("build", jar);
                  if (match !== undefined && match$1 !== undefined && match$2 !== undefined && match$3 !== undefined && match$4 !== undefined) {
                    if (match$4 === "CANARY" && Caml_obj.caml_notequal(Js_dict.get(req.headers, "host"), Belt_Option.map(URLUtils$SmartcutsMacros.$$URL.fromString(process.env.NEXT_PUBLIC_CANARY_ORIGIN), (function (x) {
                                  return x.host;
                                })))) {
                      res.writeHead(302, Js_dict.fromList({
                                hd: [
                                  "Location",
                                  process.env.NEXT_PUBLIC_CANARY_ORIGIN + req.url
                                ],
                                tl: /* [] */0
                              }));
                      res.end();
                      return ;
                    }
                    var arg = Belt_Option.map(getCookie("finished_onboarding", jar), (function (jsonString) {
                            return Json_decode.bool(JSON.parse(jsonString));
                          }));
                    var pageProps_build = Js_null.fromOption(getCookie("build", jar));
                    var pageProps_userFlags = OptionUtils$SmartcutsMacros.withDefault([], maybeDecodeUserFlags(getCookie("user_flags", jar)));
                    var pageProps_finishedOnboarding = (function (param) {
                          return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                        })(false);
                    var pageProps = {
                      token: match,
                      userId: match$1,
                      email: match$2,
                      role: match$3,
                      build: pageProps_build,
                      userFlags: pageProps_userFlags,
                      finishedOnboarding: pageProps_finishedOnboarding
                    };
                    return resolve({
                                props: pageProps
                              });
                  }
                  res.writeHead(302, Js_dict.fromList({
                            hd: [
                              "Location",
                              "/login"
                            ],
                            tl: /* [] */0
                          }));
                  res.end();
                  return ;
                }
                res.writeHead(302, Js_dict.fromList({
                          hd: [
                            "Location",
                            "/login"
                          ],
                          tl: /* [] */0
                        }));
                res.end();
                
              }));
}

function getServerSidePropsWithoutRedirectLogin(param) {
  var req = param.req;
  return new Promise((function (resolve, param) {
                var cookie = Js_dict.get(req.headers, "cookie");
                var props;
                if (cookie !== undefined) {
                  var jar = $$String.split_on_char(/* ';' */59, cookie);
                  var tmp = {
                    userFlags: OptionUtils$SmartcutsMacros.withDefault([], maybeDecodeUserFlags(getCookie("user_flags", jar)))
                  };
                  var tmp$1 = getCookie(process.env.NEXT_PUBLIC_FAUNA_SECRET_COOKIE_NAME, jar);
                  if (tmp$1 !== undefined) {
                    tmp.token = Caml_option.valFromOption(tmp$1);
                  }
                  var tmp$2 = getCookie("userId", jar);
                  if (tmp$2 !== undefined) {
                    tmp.userId = Caml_option.valFromOption(tmp$2);
                  }
                  var tmp$3 = getCookie("email", jar);
                  if (tmp$3 !== undefined) {
                    tmp.email = Caml_option.valFromOption(tmp$3);
                  }
                  var tmp$4 = getCookie("role", jar);
                  if (tmp$4 !== undefined) {
                    tmp.role = Caml_option.valFromOption(tmp$4);
                  }
                  var tmp$5 = getCookie("build", jar);
                  if (tmp$5 !== undefined) {
                    tmp.build = Caml_option.valFromOption(tmp$5);
                  }
                  props = tmp;
                } else {
                  props = {
                    userFlags: []
                  };
                }
                return resolve({
                            props: props
                          });
              }));
}

var empty_build = null;

var empty_userFlags = [];

var empty = {
  token: "",
  userId: "",
  email: "",
  role: "",
  build: empty_build,
  userFlags: empty_userFlags,
  finishedOnboarding: false
};

function fromCookieJar(jar) {
  var match = getCookie(process.env.NEXT_PUBLIC_FAUNA_SECRET_COOKIE_NAME, jar);
  var match$1 = getCookie("userId", jar);
  var match$2 = getCookie("email", jar);
  var match$3 = getCookie("role", jar);
  if (match === undefined) {
    return empty;
  }
  if (match$1 === undefined) {
    return empty;
  }
  if (match$2 === undefined) {
    return empty;
  }
  if (match$3 === undefined) {
    return empty;
  }
  var arg = Belt_Option.map(getCookie("finished_onboarding", jar), (function (jsonString) {
          return Json_decode.bool(JSON.parse(jsonString));
        }));
  return {
          token: match,
          userId: match$1,
          email: match$2,
          role: match$3,
          build: Js_null.fromOption(getCookie("build", jar)),
          userFlags: OptionUtils$SmartcutsMacros.withDefault([], maybeDecodeUserFlags(getCookie("user_flags", jar))),
          finishedOnboarding: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
              })(false)
        };
}

var ServerSidePropsForLoadAuth = {
  empty: empty,
  fromCookieJar: fromCookieJar
};

var blacklistIPs = ["146.168.150.173"];

function getServerSidePropsForLoadAuth(param) {
  var query = param.query;
  var res = param.res;
  var req = param.req;
  var ip = Js_dict.get(req.headers, "x-forwarded-for");
  var shouldBlockIP = ip !== undefined ? $$Array.mem(ip, blacklistIPs) : false;
  return new Promise((function (resolve, param) {
                var arg = OptionUtils$SmartcutsMacros.map(Js_dict.get(req.headers, "cookie"), make);
                var maybeCookieJarAndToken = (function (param) {
                      return OptionUtils$SmartcutsMacros.andThen(param, arg);
                    })(function (jar) {
                      return OptionUtils$SmartcutsMacros.map(getCookie(process.env.NEXT_PUBLIC_FAUNA_SECRET_COOKIE_NAME, jar), (function (token) {
                                    return [
                                            jar,
                                            token
                                          ];
                                  }));
                    });
                var pagePropsPromise;
                if (shouldBlockIP || maybeCookieJarAndToken === undefined) {
                  pagePropsPromise = Promise.resolve(empty);
                } else {
                  var jar = maybeCookieJarAndToken[0];
                  var match = Js_dict.get(query, "forceDbIdentityCheck");
                  if (match !== undefined) {
                    switch (match) {
                      case "false" :
                          pagePropsPromise = Promise.resolve(fromCookieJar(jar));
                          break;
                      case "true" :
                          var client = new Faunadb.Client({
                                secret: maybeCookieJarAndToken[1]
                              });
                          pagePropsPromise = client.query(Query.CurrentIdentity()).then(function (_identity) {
                                  return Promise.resolve(fromCookieJar(jar));
                                }).catch(function (err) {
                                console.error("Error while calling q.CurrentIdentity()", err);
                                var cookieDomain = "." + new URL(process.env.NEXT_PUBLIC_ORIGIN).hostname;
                                var cookieSerialized = Cookie.serialize(process.env.NEXT_PUBLIC_FAUNA_SECRET_COOKIE_NAME, "", {
                                      sameSite: "lax",
                                      secure: process.env.NODE_ENV === "production",
                                      maxAge: -1,
                                      httpOnly: true,
                                      path: "/",
                                      domain: cookieDomain
                                    });
                                res.setHeader("Set-Cookie", [cookieSerialized]);
                                return Promise.resolve(empty);
                              });
                          break;
                      default:
                        pagePropsPromise = Promise.resolve(fromCookieJar(jar));
                    }
                  } else {
                    pagePropsPromise = Promise.resolve(fromCookieJar(jar));
                  }
                }
                pagePropsPromise.then(function (pageProps) {
                      resolve({
                            props: pageProps
                          });
                      return Promise.resolve(undefined);
                    });
                
              }));
}

function loadApolloClient(token) {
  var isBrowser = typeof window !== "undefined";
  if (!isBrowser) {
    return Apollo$SmartcutsMacros.makeClient(undefined, token, undefined);
  }
  var globalClient = $$global.apolloClient;
  if (globalClient !== undefined) {
    return globalClient;
  }
  var client = Apollo$SmartcutsMacros.makeClient(undefined, token, undefined);
  $$global.apolloClient = client;
  return client;
}

function logout(router) {
  return fetch("/api/logout").then(function (res) {
              var match = res.status;
              if (match !== 200) {
                return Promise.resolve(undefined);
              } else {
                window.analytics.reset();
                router.push("/login", undefined, undefined);
                return Promise.resolve(undefined);
              }
            });
}

exports.IdentityResponse = IdentityResponse;
exports.CookieJar = CookieJar;
exports.$$global = $$global;
exports.setGlobalApolloClient = setGlobalApolloClient;
exports.OptionalPageProps = OptionalPageProps;
exports.getServerSideProps = getServerSideProps;
exports.getServerSidePropsWithoutRedirectLogin = getServerSidePropsWithoutRedirectLogin;
exports.ServerSidePropsForLoadAuth = ServerSidePropsForLoadAuth;
exports.blacklistIPs = blacklistIPs;
exports.getServerSidePropsForLoadAuth = getServerSidePropsForLoadAuth;
exports.loadApolloClient = loadApolloClient;
exports.logout = logout;
/* cookie Not a pure module */
